import React from 'react';
import styles from '../ChatWidget.module.scss';
import nekstAiIcon from './nekstAiIcon.png';

interface ChatFabProps {
  onClick: () => void;
}

export default function ChatFab(props: ChatFabProps) {
  return (
    <button
      type="button"
      className={styles.fab}
      onClick={props.onClick}
      aria-label="Open chat"
      data-testid="chat-fab"
    >
      <img src={nekstAiIcon} alt="Nekst AI" width={56} height={56} />
    </button>
  );
}
